import axios from 'axios';
import { authInterceptor } from './auth.interceptor';
import { defaultConfig } from '../../../config-env';
import { ROUTES_PATH } from '../routes/routesConstants';
import { store } from '../store/store';
import { setAlert } from '@sonifi/wb-notifier/store/notifierSlice';

const instance = axios.create({
  baseURL: defaultConfig.apiUri,
  withCredentials: true,
});

const instanceRaw = axios.create();

const instanceRawWithAuth = axios.create({ withCredentials: true });

// Add a request interceptor
instance.interceptors.request.use(authInterceptor, (error) =>
  Promise.reject(error),
);

// Add a response interceptor
instance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      sessionStorage.clear();
      window.location.href =
        error.response.status === 401 ? '/' : `/${ROUTES_PATH.NO_AUTH}`;
    }
    if (error.response?.status === 500) {
      store.dispatch(
        setAlert({
          title: 'Server Error',
          content: 'Oops! Something went wrong',
          type: 'danger',
          show: true,
          dismissable: true,
        }),
      );
    }
    return Promise.reject(error.response?.data?.errors || error);
  },
);

// Add a request interceptor
instanceRawWithAuth.interceptors.request.use(authInterceptor, (error) =>
  Promise.reject(error),
);

export default {
  delete: instance.delete,
  get: instance.get,
  getRaw: instanceRaw.get,
  getRawAuth: instanceRawWithAuth.get,
  patch: instance.patch,
  patchRaw: instanceRaw.patch,
  patchRawAuth: instanceRawWithAuth.patch,
  post: instance.post,
  postRaw: instanceRaw.post,
  put: instance.put,
};
